/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2025-01-21 15:05:43
 * @FilePath: \crane-safety-manager\src\pages\VehicleModal.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect } from 'react';
import { Form } from 'antd';
import { ModalForm, ProForm, ProFormGroup, ProFormList, ProFormSelect, ProFormText } from '@ant-design/pro-components';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import '../assets/scss/_custom.scss';

const PoleModal = ({ open, pole, onOpenChange, onOk, isEdit }) => {
    const [form] = Form.useForm();

    const sitesList = useSelector(state => state.Sites.dataList);
    const filedRules = {
        siteId: [{ required: true, message: '请选择所属工地' }],
        position: [{ required: true, message: '请输入位置' }],
        sn: [{ required: true, message: '请输入设备序列号' }],
        deviceSerial: [{ required: true, message: '请输入摄像头序列号' }],
        validateCode: [{ required: true, message: '请输入摄像头验证码' }],
        name: [{ required: true, message: '姓名' }],
        phone: [{ required: true, message: '电话' },{pattern: /^1\d{10}$/,message: '请输入正确的手机号'},]
    };

    useEffect(() => {
        if (!_.isObject(pole) || _.isEmpty(pole)) {
            form.setFieldsValue(null);
            form.isFieldsTouched();
            console.log('resetFields');
            return;
        }
        form.setFieldsValue({ ...pole });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pole]);

    return (
        <ModalForm forceRender getContainer={false} title={isEdit ? '编辑' : '新增'} open={open} form={form} autoFocusFirstInput initialValues={pole} modalProps={{ destroyOnClose: true }} submitTimeout={2000} onFinish={onOk} onOpenChange={onOpenChange}>
            <ProForm.Group>
                <ProFormSelect width="md" name="siteId" label="所属工地" rules={filedRules['siteId']} placeholder="请选择所属工地" options={(sitesList || []).map(x => ({ label: x.siteName, value: x.id }))} />
                <ProFormText width="md" name="position" label="位置" rules={filedRules['position']} placeholder="位置" />
            </ProForm.Group>
            <ProForm.Group>
                <ProFormText width="md" name="sn" label="设备序列号" rules={filedRules['sn']} placeholder="设备序列号" />
                <ProFormText width="md" name="deviceSerial" label="摄像头序列号" rules={filedRules['deviceSerial']} placeholder="摄像头序列号" />
                <ProFormText width="md" name="validateCode" label="摄像头验证码" rules={filedRules['validateCode']} placeholder="摄像头验证码" />
            </ProForm.Group>
            <ProFormList className="worker-list" name="workers" creatorButtonProps={{ position: 'bottom', creatorButtonText: '添加人员' }}>
                <ProFormGroup style={{ gap: '0 24px' }} >
                    <ProFormText key="name" width="sm" name="name" label="姓名" rules={filedRules['name']} placeholder="姓名" />
                    <ProFormText key='phone' width='sm' name='phone' label='电话' rules={filedRules['phone']} placeholder={'电话'}/>
                </ProFormGroup>
            </ProFormList>
        </ModalForm>
    );
};

export default PoleModal;
